import { Typography } from '@mui/material';
import moment from 'moment';
import { FC, useState } from 'react';
import { IvPatientInfo } from '../../../types/iv-patient-info';
import {
  ExpandMoreButton,
  ExpandMoreButtonWrapper,
  InsuranceInfoList,
  InsuranceInfoListItem,
  MoreInsuranceInfo
} from './styles';

type InsuranceInfoProps = {
  patientInfo: IvPatientInfo;
};

export const InsuranceInfo: FC<InsuranceInfoProps> = (props: InsuranceInfoProps) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);
  const patientInfo = props.patientInfo;
  return (
    <>
      {patientInfo?.insuranceInfo && (
        <MoreInsuranceInfo>
          <ExpandMoreButtonWrapper>
            <ExpandMoreButton expanded={detailsExpanded} onClick={() => setDetailsExpanded((x) => !x)} />
            <Typography variant="body2" onClick={() => setDetailsExpanded((x) => !x)}>
              <b>{detailsExpanded ? 'View less Insurance Info' : 'View more Insurance Info'}</b>
            </Typography>
          </ExpandMoreButtonWrapper>
          <InsuranceInfoList expanded={detailsExpanded}>
            <InsuranceInfoListItem
              name="Subscriber First Name"
              value={patientInfo?.insuranceInfo.subscriberFirstName || 'Unknown'}
            />
            <InsuranceInfoListItem
              name="Subscriber Last Name"
              value={patientInfo?.insuranceInfo.subscriberLastName || 'Unknown'}
            />
            <InsuranceInfoListItem
              name="Subscriber DOB"
              value={
                patientInfo?.insuranceInfo.subscriberDateOfBirth
                  ? moment(patientInfo.insuranceInfo?.subscriberDateOfBirth).format('MMM DD, YYYY')
                  : 'Unknown'
              }
            />
            <InsuranceInfoListItem name="Group ID" value={patientInfo?.insuranceInfo?.groupId || 'Unknown'} />
            <InsuranceInfoListItem name="Member ID" value={patientInfo?.insuranceInfo?.memberId || 'Unknown'} />
            <InsuranceInfoListItem name="Carrier ID" value={patientInfo?.insuranceInfo?.carrierId || 'Unknown'} />
          </InsuranceInfoList>
        </MoreInsuranceInfo>
      )}
    </>
  );
};
